import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgageRateTracker from "@/pages/MortgageRateTracker";

export const Route = createFileRoute("/mortgage-rates/")({
  head: () => seoHead("/mortgage-rates/"),
  component: MortgageRateTracker,
});
